import {defaultAppConfig} from './default-app-config';

type AppEnvironment = 'stage' | 'dev';

interface IAppConstants {
  APP_ENVIRONMENT: AppEnvironment;
}

export const AppConstants: IAppConstants = {
  APP_ENVIRONMENT: 'stage',
};

export enum FeatureAppNames {
  STORY_STREAM = 'storystream',
  DEFAULT = 'default',
}

export const appsUMD = {
  [FeatureAppNames.STORY_STREAM]: '/assets/storystream/storystream-umd.js',
  [FeatureAppNames.DEFAULT]: defaultAppConfig.appsUMD,
};

export const appsCommonsJS = {
  [FeatureAppNames.STORY_STREAM]: '/assets/storystream/storystream-commonjs.js',
  [FeatureAppNames.DEFAULT]: defaultAppConfig.appsCommonsJS,
};
